export enum ReportMetric {
  Marketplace = 'MARKETPLACE',
  Ecpm = 'ECPM',
  RevenueBids = 'REVENUE_BIDS',
  RevenueFill = 'REVENUE_FILL',
  PreMpRevenue = 'PRE_MP_REVENUE',
  AdImpressionsNonStitched = 'AD_IMPRESSIONS_NON_STITCHED',
  FilledImpressionsNonStitched = 'FILLED_IMPRESSIONS_NON_STITCHED',
  AgencyId = 'AGENCY_ID',
  AgencyName = 'AGENCY_NAME',
  IiqResolvedRequests = 'IIQ_RESOLVED_REQUESTS',
  IiqAdImpressions = 'IIQ_AD_IMPRESSIONS',
  IiqRevenue = 'IIQ_REVENUE',
  IiqArm = 'IIQ_ARM',
  Browser = 'BROWSER',
  Hour = 'HOUR',
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR',
  PublisherName = 'PUBLISHER_NAME',
  PublisherId = 'PUBLISHER_ID',
  Domain = 'DOMAIN',
  Deal = 'DEAL',
  AuctionType = 'AUCTION_TYPE',
  AppId = 'APP_ID',
  AppBundleId = 'APP_BUNDLE_ID',
  BidderCode = 'BIDDER_CODE',
  DemandPartnerId = 'DEMAND_PARTNER_ID',
  DemandPartnerName = 'DEMAND_PARTNER_NAME',
  DemandPartnerOwnerId = 'DEMAND_PARTNER_OWNER_ID',
  DemandPartnerOwnerName = 'DEMAND_PARTNER_OWNER_NAME',
  DpAdRequests = 'DP_AD_REQUESTS',
  DpAdRequestRatio = 'DP_AD_REQUEST_RATIO',
  AdImpressions = 'AD_IMPRESSIONS',
  AdRequests = 'AD_REQUESTS',
  AdRequestsFilled = 'AD_REQUESTS_FILLED',
  AdUnitImpressions = 'AD_UNIT_IMPRESSIONS',
  FilledImpressions = 'FILLED_IMPRESSIONS',
  RenderRate = 'RENDER_RATE',
  ResponseRate = 'RESPONSE_RATE',
  Revenue = 'REVENUE',
  NetRevenue = 'NET_REVENUE',
  Rpm = 'RPM',
  Srpm = 'SRPM',
  MarginPct = 'MARGIN_PCT',
  NetworkMarginPct = 'NETWORK_MARGIN_PCT',
  GrossRevenue = 'GROSS_REVENUE',
  PubRevenue = 'PUB_REVENUE',
  Profit = 'PROFIT',
  PublisherRevenueShare = 'PUBLISHER_REVENUE_SHARE',
  Bids = 'BIDS',
  BidFillRatio = 'BID_FILL_RATIO',
  WonBids = 'WON_BIDS',
  LostRatio = 'LOST_RATIO',
  WinRatio = 'WIN_RATIO',
  BidRatio = 'BID_RATIO',
  InsertionRate = 'INSERTION_RATE',
  LostBids = 'LOST_BIDS',
  BidWinLostRatio = 'BID_WIN_LOST_RATIO',
  ContentImpressions = 'CONTENT_IMPRESSIONS',
  StichImpressions = 'STICH_IMPRESSIONS',
  FilledImpressionsStitched = 'FILLED_IMPRESSIONS_STITCHED',
  AdImpressionsStitched = 'AD_IMPRESSIONS_STITCHED',
  ProductType = 'PRODUCT_TYPE',
  PublisherNetwork = 'PUBLISHER_NETWORK',
  PublisherNetworkCpm = 'PUBLISHER_NETWORK_CPM',
  PublisherCpm = 'PUBLISHER_CPM',
  VideoId = 'VIDEO_ID',
  VideoName = 'VIDEO_NAME',
  Video = 'VIDEO',
  ContentType = 'CONTENT_TYPE',
  ContentTitle = 'CONTENT_TITLE',
  ContentSeries = 'CONTENT_SERIES',
  ContentGenre = 'CONTENT_GENRE',
  ContentCat = 'CONTENT_CAT',
  ContentRating = 'CONTENT_RATING',
  ContentChannelName = 'CONTENT_CHANNEL_NAME',
  ContentNetworkName = 'CONTENT_NETWORK_NAME',
  ContentLanguage = 'CONTENT_LANGUAGE',
  ContentLivestream = 'CONTENT_LIVESTREAM',
  ImmuVideoPlayed = 'IMMU_VIDEO_PLAYED',
  ContentRequest = 'CONTENT_REQUEST',
  Page = 'PAGE',
  Xp = 'XP',
  Xp1 = 'XP1',
  Xp2 = 'XP2',
  Xp3 = 'XP3',
  NetworkId = 'NETWORK_ID',
  NetworkName = 'NETWORK_NAME',
  BundleRevenueShare = 'BUNDLE_REVENUE_SHARE',
  BundleCpm = 'BUNDLE_CPM',
  NetworkSaasType = 'NETWORK_SAAS_TYPE',
  NetworkSaasValue = 'NETWORK_SAAS_VALUE',
  NetworkSaasMetric = 'NETWORK_SAAS_METRIC',
  NetworkSaasFee = 'NETWORK_SAAS_FEE',
  NetworkRevenue = 'NETWORK_REVENUE',
  NetworkProfit = 'NETWORK_PROFIT',
  NetworkRevenuePct = 'NETWORK_REVENUE_PCT',
  SchainAsi = 'SCHAIN_ASI',
  CrId = 'CR_ID',
  Adomain = 'ADOMAIN',
  SchainNodeDomain = 'SCHAIN_NODE_DOMAIN',
  WonBidsCache = 'WON_BIDS_CACHE',
  FilledImpressionsCache = 'FILLED_IMPRESSIONS_CACHE',
  AdImpressionsCache = 'AD_IMPRESSIONS_CACHE',
  RevenueCache = 'REVENUE_CACHE',
  PubRevenueCache = 'PUB_REVENUE_CACHE',
  RpmNet = 'RPM_NET',
  Placement = 'PLACEMENT',
  PlacementId = 'PLACEMENT_ID',
  BidsLi = 'BIDS_LI',
  WonBidsLi = 'WON_BIDS_LI',
  FilledImpressionsLi = 'FILLED_IMPRESSIONS_LI',
  AdImpressionsLi = 'AD_IMPRESSIONS_LI',
  RevenueLi = 'REVENUE_LI',
  PubRevenueLi = 'PUB_REVENUE_LI',
  RpmLi = 'RPM_LI',
  RenderRateLi = 'RENDER_RATE_LI',
  LineItem = 'LINE_ITEM',
  LineItemId = 'LINE_ITEM_ID',
  Order = 'ORDER',
  DemandIntegration = 'DEMAND_INTEGRATION',
  DemandIntegrationId = 'DEMAND_INTEGRATION_ID',
  RevenueStitched = 'REVENUE_STITCHED',
  RpmStitched = 'RPM_STITCHED',
  RenderRateStitched = 'RENDER_RATE_STITCHED',
  Country = 'COUNTRY',
  Region = 'REGION',
  DataCenter = 'DATA_CENTER',
  ErrorMessage = 'ERROR_MESSAGE',
  ErrorCode = 'ERROR_CODE',
  Platform = 'PLATFORM',
  PlatformId = 'PLATFORM_ID',
  AppStoreId = 'APP_STORE_ID',
  AppStoreUrl = 'APP_STORE_URL',
  MpRevenue = 'MP_REVENUE',
  PublisherSecondaryId = 'PUBLISHER_SECONDARY_ID',
  Errors = 'ERRORS',
  AdStart = 'AD_START',
  AdQuartile1 = 'AD_QUARTILE_1',
  AdMid = 'AD_MID',
  AdQuartile3 = 'AD_QUARTILE_3',
  AdCompletion = 'AD_COMPLETION',
  AdImpressionsStitchedPct = 'AD_IMPRESSIONS_STITCHED_PCT',
  PubRenderRate = 'PUB_RENDER_RATE',
  PubAdImpressions = 'PUB_AD_IMPRESSIONS',
  PubRpm = 'PUB_RPM',
  PublisherRevenueShareIo = 'PUBLISHER_REVENUE_SHARE_IO',
  DpFillRatio = 'DP_FILL_RATIO',
  DvSegment = 'DV_SEGMENT',
  AdImpressionsDvIqm = 'AD_IMPRESSIONS_DV_IQM',
  RevenuePct = 'REVENUE_PCT',
  Rps = 'RPS',
  PubGrossRevenue = 'PUB_GROSS_REVENUE',
  BcFind = 'BC_FIND',
  BcStore = 'BC_STORE',
  BcUnlock = 'BC_UNLOCK',
  BcUse = 'BC_USE',
  BidCpm = 'BID_CPM',
  FillCpm = 'FILL_CPM',
  RpmFill = 'RPM_FILL',
  IvtProvider = 'IVT_PROVIDER',
  IvtType = 'IVT_TYPE',
  IvtTotalEvents = 'IVT_TOTAL_EVENTS',
  IvtInvalidTraffic = 'IVT_INVALID_TRAFFIC',
  IvtInvalidTrafficPct = 'IVT_INVALID_TRAFFIC_PCT',
  IvtSofisticated = 'IVT_SOFISTICATED',
  IvtSofisticatedPct = 'IVT_SOFISTICATED_PCT',
  IvtGeneral = 'IVT_GENERAL',
  IvtGeneralPct = 'IVT_GENERAL_PCT',
  IvtValidTraffic = 'IVT_VALID_TRAFFIC',
  IvtValidTrafficPct = 'IVT_VALID_TRAFFIC_PCT',
  WebVideoPageRequest = 'WEB_VIDEO_PAGE_REQUEST',
  BrandName = 'BRAND_NAME',
  BrandId = 'BRAND_ID',
  AdvertiserName = 'ADVERTISER_NAME',
  AdvertiserId = 'ADVERTISER_ID',
  DeviceType = 'DEVICE_TYPE',
  BidfloorReq = 'BIDFLOOR_REQ',
  OutgoingFloor = 'OUTGOING_FLOOR',
  FloorEcpm = 'FLOOR_ECPM',
  AdClicks = 'AD_CLICKS',
  Ctr = 'CTR',
  ClickCpm = 'CLICK_CPM',
  CreativeId = 'CREATIVE_ID',
  CreativeName = 'CREATIVE_NAME',
  View = 'VIEW',
  ViewPct = 'VIEW_PCT',
  ApplicationId = 'APPLICATION_ID',
  ApplicationName = 'APPLICATION_NAME',
  LrSegment = 'LR_SEGMENT',
  LrSegmentName = 'LR_SEGMENT_NAME',
  LrSegmentCost = 'LR_SEGMENT_COST',
  StitchCpmCost = 'STITCH_CPM_COST',
  AppName = 'APP_NAME',
  Timeouts = 'TIMEOUTS',
  Omidpn = 'OMIDPN',
  Omidpv = 'OMIDPV',
}

export enum ReportDimension {
  Video = 'VIDEO',
  Marketplace = 'MARKETPLACE',
  Agency = 'AGENCY',
  Total = 'TOTAL',
  IiqArm = 'IIQ_ARM',
  Browser = 'BROWSER',
  Hour = 'HOUR',
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR',
  Publisher = 'PUBLISHER',
  PublisherDomain = 'PUBLISHER_DOMAIN',
  App = 'APP',
  BidderCode = 'BIDDER_CODE',
  DemandPartner = 'DEMAND_PARTNER',
  DemandPartnerOwner = 'DEMAND_PARTNER_OWNER',
  ProductType = 'PRODUCT_TYPE',
  ContentType = 'CONTENT_TYPE',
  ContentTitle = 'CONTENT_TITLE',
  ContentSeries = 'CONTENT_SERIES',
  ContentGenre = 'CONTENT_GENRE',
  ContentCat = 'CONTENT_CAT',
  ContentRating = 'CONTENT_RATING',
  ContentChannelName = 'CONTENT_CHANNEL_NAME',
  ContentNetworkName = 'CONTENT_NETWORK_NAME',
  ContentLanguage = 'CONTENT_LANGUAGE',
  ContentLivestream = 'CONTENT_LIVESTREAM',
  PublisherPage = 'PUBLISHER_PAGE',
  Network = 'NETWORK',
  Xp = 'XP',
  Xp1 = 'XP1',
  Xp2 = 'XP2',
  Xp3 = 'XP3',
  SchainAsi = 'SCHAIN_ASI',
  CrId = 'CR_ID',
  Adomain = 'ADOMAIN',
  SchainNodeDomain = 'SCHAIN_NODE_DOMAIN',
  Placement = 'PLACEMENT',
  DemandIntegration = 'DEMAND_INTEGRATION',
  Deal = 'DEAL',
  AuctionType = 'AUCTION_TYPE',
  LineItem = 'LINE_ITEM',
  Order = 'ORDER',
  Country = 'COUNTRY',
  Region = 'REGION',
  DataCenter = 'DATA_CENTER',
  ErrorCode = 'ERROR_CODE',
  AppStore = 'APP_STORE',
  Platform = 'PLATFORM',
  DvSegment = 'DV_SEGMENT',
  IvtProvider = 'IVT_PROVIDER',
  IvtType = 'IVT_TYPE',
  Brand = 'BRAND',
  Advertiser = 'ADVERTISER',
  DeviceType = 'DEVICE_TYPE',
  BidfloorReq = 'BIDFLOOR_REQ',
  Creative = 'CREATIVE',
  LrSegment = 'LR_SEGMENT',
  Application = 'APPLICATION',
  Omidpn = 'OMIDPN',
  Omidpv = 'OMIDPV',
}

export enum ReportMetricFormat {
  String = 'STRING',
  Number = 'NUMBER',
  Decimal = 'DECIMAL',
  DateTime = 'DATE_TIME',
  Percentage = 'PERCENTAGE',
  PercentagePlain = 'PERCENTAGE_PLAIN',
  Currency = 'CURRENCY',
  Duration = 'DURATION',
  BidFloor = 'BID_FLOOR',
}

export enum ReportType {
  IntentIq = 'INTENT_IQ',
  All = 'ALL',
  Exchange = 'EXCHANGE',
}

export enum ReportDateRangeType {
  Today = 'TODAY',
  Yesterday = 'YESTERDAY',
  ThisWeek = 'THIS_WEEK',
  Last7Days = 'LAST_7_DAYS',
  ThisMonth = 'THIS_MONTH',
  Last30Days = 'LAST_30_DAYS',
  LastMonth = 'LAST_MONTH',
  Last3Months = 'LAST_3_MONTHS',
  Last6Months = 'LAST_6_MONTHS',
  ThisYear = 'THIS_YEAR',
}

export enum ReportTimeGranularity {
  Hour = 'HOUR',
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR',
}

export enum ReportFieldRailView {
  All = 'ALL',
  Dimensions = 'DIMENSIONS',
  Metrics = 'METRICS',
}

export enum ReportExplorerScope {
  Agency = 'AGENCY',
  Standard = 'STANDARD',
  Publisher = 'PUBLISHER',
}

export enum ReportFilterField {
  Agency = 'AGENCY',
  Publisher = 'PUBLISHER',
  DemandPartner = 'DEMAND_PARTNER',
  BidderCode = 'BIDDER_CODE',
  BundleId = 'BUNDLE_ID',
  Placement = 'PLACEMENT',
  Country = 'COUNTRY',
  DemandIntegration = 'DEMAND_INTEGRATION',
  Platform = 'PLATFORM',
  LineItem = 'LINE_ITEM',
  Application = 'APPLICATION',
  Domain = 'DOMAIN',
}

export enum ReportFilterMode {
  Include = 'INCLUDE',
  Exclude = 'EXCLUDE',
}

export enum ReportFilterLookupMode {
  Local = 'LOCAL',
  Server = 'SERVER',
}

export enum ReportFilterLookupStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export enum ReportCatalogGroup {
  General = 'GENERAL',
  Kpi = 'KPI',
  Exchange = 'EXCHANGE',
  Finance = 'FINANCE',
  Content = 'CONTENT',
  Errors = 'ERRORS',
  Stitcher = 'STITCHER',
  Cache = 'CACHE',
  Network = 'NETWORK',
  Campaigns = 'CAMPAIGNS',
  WebVideo = 'WEB_VIDEO',
  Ivt = 'IVT',
  TimeGranularity = 'TIME_GRANULARITY',
}
